<!-- type is added to get rid of type error warning. -->

<ngx-spinner type=" "> {{ "Loading" | translate }}... </ngx-spinner>

<div class="container">
    <student-portal-header
        [signedInUser]="user"
        (logout)="logout()"
        (login)="login()"
        (notificationsClickEvent)="drawer.toggle()"
        class="header"
    >
    </student-portal-header>

    <mat-drawer-container class=".white-color drawer-container" autosize>
        <mat-drawer #drawer mode="over" position="end" class="drawer">
            <app-notifications
                [notifications]="notifications$ | async"
                (markListAsRead)="markListAsRead($event)"
            ></app-notifications>
        </mat-drawer>
        <div>
            <router-outlet #outlet="outlet" class="content"> </router-outlet>
        </div>
    </mat-drawer-container>

    <app-footer
        [clientVersion]="AppSettings.version"
        class="hide-footer footer"
    ></app-footer>
</div>

